import { useMediaQuery, useTheme } from '@mui/material'

export function useIsPhoneLayout(): boolean {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true })
}

export function useIsBelowDesktopLayout(): boolean {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('lg'), { noSsr: true })
}

export function useIsBelowMdLayout(): boolean {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('md'), { noSsr: true })
}
